import { Component, OnInit } from '@angular/core';
import {timer} from 'rxjs';
import {EnvironmentService, TranslateService} from "bos-commons";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-external-login-success',
  templateUrl: './external-login-success.component.html',
  styleUrls: ['./external-login-success.component.scss']
})
export class ExternalLoginSuccessComponent implements OnInit {

  constructor(private enviromentService: EnvironmentService, private translateService: TranslateService, private route: ActivatedRoute) { }

  secondLeft: number = 5;
  interval: any;
  infoText: string = "";
  code: string = "";
  state: string = "";

  startTimer() {
    this.updateInfoText();
    this.interval = setInterval(() => {
      if(this.secondLeft > 0) {
        this.secondLeft--;
        this.updateInfoText();
      } else {
        this.stopTimer();
        this.redirectToApp();
      }
    },1000);
  }

  private updateInfoText() {
    this.infoText = this.translateService.translateWithArgs('externallogin.success', ['' + this.secondLeft]);
  }

  stopTimer() {
    clearInterval(this.interval);
  }
  ngOnInit(): void {
    const routeParams = this.route.snapshot.queryParams;
    this.code = routeParams.code as unknown as string;
    this.state = routeParams.state as unknown as string;
    this.startTimer();
  }

  redirectToApp() {
    window.open( this.enviromentService.environment.externalLinkApp + '?code=' + this.code + '&state=' + this.state);
  }

}
